import { render, staticRenderFns } from "./actionDialog.vue?vue&type=template&id=0878bff7"
import script from "./actionDialog.vue?vue&type=script&lang=js"
export * from "./actionDialog.vue?vue&type=script&lang=js"
import style0 from "./actionDialog.vue?vue&type=style&index=0&id=0878bff7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports